import React from "react";

import { ArrowheadDown, ArrowheadUp } from "../../../icons";
import { Box, Typography } from "@mui/material";

interface Props {
  value: number;
  prefix?: string;
  suffix?: string;
}

export function MetricTileChangeValue({ prefix, suffix, value = 0 }: Props) {
  return (
    <Typography
      sx={{
        color:
          value > 0 ? "primary.dark" : value < 0 ? "error.main" : undefined,
      }}
      variant="h5"
      color="textSecondary"
      noWrap>
      {value !== 0 && (
        <Box
          component="span"
          sx={{
            position: "relative",
            margin: "0 5px",
            ...(value > 0
              ? {
                  top: 0,
                  left: -2,
                }
              : {}),
            ...(value < 0
              ? {
                  top: -2,
                  left: -2,
                }
              : {}),
          }}>
          {value > 0 && <ArrowheadUp />}
          {value < 0 && <ArrowheadDown />}
        </Box>
      )}
      {prefix}
      {Math.abs(value)}
      {suffix}
    </Typography>
  );
}
